import './new-leave-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateLeaveType } from "@core/query/leave-type.query";
import { LeaveTypeFormRule, LeaveTypeFormSchema } from "@core/form/form.rule";
import { leaveTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormLeaveType from "../form-leave-type/form-leave-type";

export function LeaveType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateLeaveType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New LeaveType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addLeaveType, isLoading: isCreating } =
    useQyCreateLeaveType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<LeaveTypeFormSchema>({
    defaultValues: leaveTypeFormDefault,
    resolver: zodResolver(LeaveTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: LeaveTypeFormSchema) => {
    const formData = mapCreateLeaveType(form);
    addLeaveType(formData);
  };
  const handleValidateError = (err: FieldErrors<LeaveTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="LeaveType" className="leave-type">
      <HeaderContent
        title="New Leave Type"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormLeaveType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default LeaveType;